import { service } from '@ember/service';
// import AccountLinkingSlr from 'tio-employee/components/account-linking/slr';
import Component from '@glimmer/component';
import type FinancialInstitutionModel from 'tio-common/models/financial-institution';
import type RouterService from 'tio-employee/services/router';
import { t } from 'ember-intl';
import AlertBanner from 'tio-reimagined/components/alert-banner';
import { Header } from 'tio-ui/components/layout';

export default class AccountActivityLinkingRoute extends Component {
  @service declare router: RouterService;

  didLink = (institution: FinancialInstitutionModel) => {
    this.router.transitionTo('authenticated.slr.linking-confirmation', institution.legacyId);
  };

  didCancel = () => {
    this.router.transitionTo('authenticated.dashboard');
  };

  <template>
    <Header>{{t "account_linking.add_account"}}</Header>

    {{! disabling the no-bare-strings rule rather than adding translations for this
      because this is theoretically temporary }}
    <AlertBanner @intent="warning" class="border border-gray-200">
      <p class="mb-2">
        {{t "account_linking.fed_servicer_unavailable_notice"}}
        <a
          class="font-semibold hover:underline"
          href="https://fsapartners.ed.gov/knowledge-center/library/electronic-announcements/2024-04-02/updates-borrowers-federal-student-loan-and-grant-web-experience-updated-july-3-2024"
        >
          {{t "account_linking.due_to_ed_changes"}}</a>.
        {{t "account_linking.working_on_solution"}}
      </p>
      <p>
        {{t "account_linking.fed_loans_contact_support"}}
        <a
          class="font-semibold hover:underline"
          href="mailto:support@tuition.io"
          target="_blank"
          rel="noopener noreferrer"
        >{{t "account_linking.support_email"}}</a>
        {{t "account_linking.contact_with_statement"}}
      </p>
    </AlertBanner>

    {{!-- <AccountLinkingSlr @onSuccess={{this.didLink}} @onCanceled={{this.didCancel}} /> --}}
  </template>
}
